import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Collapse } from 'react-bootstrap'
// import { Collapse, Dropdown } from 'react-bootstrap'
// import { Trans } from 'react-i18next'

class Sidebar extends Component {
  state = {}

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false })
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true })
    } else {
      Object.keys(this.state).forEach((i) => {
        this.setState({ [i]: false })
      })
      this.setState({ [menuState]: true })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged()
    }
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active')
    Object.keys(this.state).forEach((i) => {
      this.setState({ [i]: false })
    })

    const dropdownPaths = [
      { path: '/apps', state: 'appsMenuOpen' },
      { path: '/my-profile', state: 'myProfile' },
      { path: '/my-team', state: 'myTeam' },
      { path: '/id-management', state: 'idManagement' },
      { path: '/income', state: 'income' },
      { path: '/fund-management', state: 'fundManagement' },
      { path: '/reports-history', state: 'reportsHistory' },
    ]

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true })
      }
    })
  }

  render() {
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          <li className="nav-item profile">
            <div className="profile-desc">
              <div className="profile-pic">
                <img
                  src="/assets/images/brand/logo-1.png"
                  alt="logo"
                  style={{ width: 60, height: 'auto' }}
                />
                <div className="profile-name">
                  <h5 className="mb-0 font-weight-normal">
                    Yevhenii Molchanov
                  </h5>
                  <span>70087329</span>
                </div>
              </div>
            </div>
          </li>
          <li
            className={
              this.isPathActive('/dashboard')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <Link className="nav-link" to="/dashboard">
              <span className="menu-icon">
                <i className="fe fe-airplay"></i>
              </span>
              <span className="menu-title">Dashboard</span>
            </Link>
          </li>
          {/* ------------ My Profile ------------- */}
          <li
            className={
              this.isPathActive('/my-profile')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <div
              className={
                this.state.myProfile ? 'nav-link menu-expanded' : 'nav-link'
              }
              onClick={() => this.toggleMenuState('myProfile')}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="fe fe-pie-chart"></i>
              </span>
              <span className="menu-title">My Profile</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.myProfile}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {' '}
                    <Link
                      className={
                        this.isPathActive('/my-profile/profile')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/my-profile/profile"
                    >
                      Profile
                    </Link>
                  </li>
                  <li className="nav-item">
                    {' '}
                    <Link
                      className={
                        this.isPathActive('/my-profile/change-password')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/my-profile/change-password"
                    >
                      Change Password
                    </Link>
                  </li>
                  <li className="nav-item">
                    {' '}
                    <Link
                      className={
                        this.isPathActive('/my-profile/change-tr-password')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/my-profile/change-tr-password"
                    >
                      Change Tr.Password
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>

          {/* ------------ My Team ------------- */}
          <li
            className={
              this.isPathActive('/my-team')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <div
              className={
                this.state.myTeam ? 'nav-link menu-expanded' : 'nav-link'
              }
              onClick={() => this.toggleMenuState('myTeam')}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="fe fe-layers"></i>
              </span>
              <span className="menu-title">My Team</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.myTeam}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/my-team/direct-refers')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/my-team/direct-refers"
                    >
                      Direct Refers
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/my-team/downline-team')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/my-team/downline-team"
                    >
                      Downline Team
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>

          {/* ------------ ID Management ------------- */}
          <li
            className={
              this.isPathActive('/id-management')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <div
              className={
                this.state.idManagement ? 'nav-link menu-expanded' : 'nav-link'
              }
              onClick={() => this.toggleMenuState('idManagement')}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="fe fe-package"></i>
              </span>
              <span className="menu-title">ID Management</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.idManagement}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/id-management/activate')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/id-management/activate"
                    >
                      Activate
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/id-management/upgrade')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/id-management/upgrade"
                    >
                      Upgrade
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>

          {/* ------------ Income ------------- */}
          <li
            className={
              this.isPathActive('/income')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <div
              className={
                this.state.income ? 'nav-link menu-expanded' : 'nav-link'
              }
              onClick={() => this.toggleMenuState('income')}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="fe fe fe-file"></i>
              </span>
              <span className="menu-title">Income</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.income}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/refer-income')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/refer-income"
                    >
                      Refer Income
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/level-income')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/level-income"
                    >
                      Level Income
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/upgrade-income')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/upgrade-income"
                    >
                      Upgrade Income
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/pool-income')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/pool-income"
                    >
                      Pool Income
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/sponsor-bonanza')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/sponsor-bonanza"
                    >
                      Sponsor Bonanza
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/boosting-board')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/boosting-board"
                    >
                      Boosting Board
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/fx-vault-profit')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/fx-vault-profit"
                    >
                      Fx Vault Profit
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/fx-vault-level')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/fx-vault-level"
                    >
                      Fx Vault Level
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/pending-refer-income')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/pending-refer-income"
                    >
                      Pending Refer Income
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/income/pending-upgrade-income')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/income/pending-upgrade-income"
                    >
                      Pending Upgrade Income
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>

          {/* ------------ Fund Manangement ------------- */}
          <li
            className={
              this.isPathActive('/fund-management')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <div
              className={
                this.state.fundManagement
                  ? 'nav-link menu-expanded'
                  : 'nav-link'
              }
              onClick={() => this.toggleMenuState('fundManagement')}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="fe fe-layout"></i>
              </span>
              <span className="menu-title">Fund Management</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.fundManagement}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/fund-management/deposit-usdt')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/fund-management/deposit-usdt"
                    >
                      Deposit USDT
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/fund-management/fund-transfer-p2p')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/fund-management/fund-transfer-p2p"
                    >
                      Fund Transfer (P2P)
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive(
                          '/fund-management/add-usdt-trc20-wallet',
                        )
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/fund-management/add-usdt-trc20-wallet"
                    >
                      Add USDT-TRC20 Wallet
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/fund-management/payout-request')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/fund-management/payout-request"
                    >
                      Payout Request
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>

          {/* ------------ Reports & History ------------- */}
          <li
            className={
              this.isPathActive('/reports-history')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <div
              className={
                this.state.reportsHistory
                  ? 'nav-link menu-expanded'
                  : 'nav-link'
              }
              onClick={() => this.toggleMenuState('reportsHistory')}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="fe fe-layers"></i>
              </span>
              <span className="menu-title">Reports & History</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.reportsHistory}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive(
                          '/reports-history/refer-income-history',
                        )
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/reports-history/refer-income-history"
                    >
                      Refer Income History
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/reports-history/hold-refer-income')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/reports-history/hold-refer-income"
                    >
                      Hold Refer Income
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/reports-history/deposit-history')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/reports-history/deposit-history"
                    >
                      Deposit History
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive(
                          '/reports-history/transaction-history',
                        )
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/reports-history/transaction-history"
                    >
                      Transaction History
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive('/reports-history/withdrawal-history')
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      to="/reports-history/withdrawal-history"
                    >
                      Withdrawal History
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>

          {/* ------------------------ */}
          <li
            className={
              this.isPathActive('/request-support')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <Link className="nav-link" to="/request-support">
              <span className="menu-icon">
                <i className="fe fe-mail"></i>
              </span>
              <span className="menu-title">Request Support</span>
            </Link>
          </li>
          <li
            className={
              this.isPathActive('/support-history')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <Link className="nav-link" to="/support-history">
              <span className="menu-icon">
                <i className="fe fe-airplay"></i>
              </span>
              <span className="menu-title">Support History</span>
            </Link>
          </li>

          <li
            className={
              this.isPathActive('/logout')
                ? 'nav-item menu-items active'
                : 'nav-item menu-items'
            }
          >
            <Link className="nav-link" to="/logout">
              <span className="menu-icon">
                <i className="fa fa-power-off"></i>
              </span>
              <span className="menu-title">Logout</span>
            </Link>
          </li>
        </ul>
      </nav>
    )
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path)
  }

  componentDidMount() {
    this.onRouteChanged()
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body')
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open')
        }
      })
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open')
        }
      })
    })
  }
}

export default withRouter(Sidebar)
